import { SensorStatus } from '../types/SensorStatus';

export const sensorStatusLabels: Record<SensorStatus, string> = {
  OUT: '부재중',
  IN: '재실',
  MEETING: '회의중',
};
